import ButtonIcon from "../../../common/buttonIcon"
import InputFiled from "../../../common/inputFiled"

const BoxSelectTimeslotInterval = (props: any) => {
  let icon = props.icon ?? "";
  let value = props.value ?? {}
  let id = props.id ?? -1;
  const clickComponent = () => {

    props.handelClick(value, id)
  }
  const updateStartDate = (input: any) => {
    props.handleChangeStardDate(input, id);
  }
  const updateEndDate = (input: any) => {
    props.handleChangeEndDate(input, id);
  }
  return (
    <div className="row">
      <div className="col-lg-5">
        <InputFiled handleChange={updateStartDate} type="time" value={value.startTime} name="numberWaitTime" />
      </div>
      <div className="col-lg-5">
        <InputFiled handleChange={updateEndDate} type="time" value={value.endTime} name="numberWaitTime" />
      </div>
      <div className="col-lg-2 text-lg-left pl-lg-0 pr-lg-0" style={{ paddingTop: 10 }}>
        <ButtonIcon handleClick={clickComponent} icon={icon} disabled={(icon === "add" && (value.startTime === "" || value.endTime === ""))} />
      </div>
    </div>
  )
}

export default BoxSelectTimeslotInterval